import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { registerUser } from '../../services/authService';
import styles from './Auth.module.css';

const Register = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [adminPin, setAdminPin] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  
  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      const { role } = await registerUser(email, password, name, adminPin);
      if (role === 'crmadmin') {
        navigate('/crm');
      } else {
        navigate('/user-portal');
      }
    } catch (err) {
      setError(err.message || 'Failed to create account.');
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.authContainer}>
      <form onSubmit={handleRegister} className={styles.authForm}>
        <h2 className={styles.title}>Create Account</h2>
        <p className={styles.subtitle}>Register to access the platform</p>
        
        <input 
          type="text" 
          value={name} 
          onChange={(e) => setName(e.target.value)} 
          placeholder="Full Name" 
          className={styles.inputField}
          required
        />
        <input 
          type="email" 
          value={email} 
          onChange={(e) => setEmail(e.target.value)} 
          placeholder="Email Address" 
          className={styles.inputField}
          required
        />
        <input 
          type="password" 
          value={password} 
          onChange={(e) => setPassword(e.target.value)} 
          placeholder="Password" 
          className={styles.inputField}
          required
        />
        <input 
          type="password" 
          value={adminPin} 
          onChange={(e) => setAdminPin(e.target.value)} 
          placeholder="Admin Registration PIN (Optional)" 
          className={styles.inputField}
        />
        
        {error && <p className={styles.error}>{error}</p>}
        
        <button type="submit" disabled={isLoading} className={styles.submitBtn}>
          {isLoading ? 'Registering...' : 'Register'}
        </button>
        
        <div className={styles.redirectLink}>
          Already have an account? <Link to="/login">Login here</Link>
        </div>
      </form>
    </div>
  );
};

export default Register;
